import { useMemo } from 'react';
import { useRecoilValueLoadable } from 'recoil';
import { elementSelector } from './selectors.js';

function useElement(elementId) {
    var elementLoadable = useRecoilValueLoadable(elementSelector(elementId));
    var memoElement = useMemo(function () {
        if (elementLoadable && elementLoadable.state === "hasValue") {
            return elementLoadable.contents;
        }
        else if (elementLoadable && elementLoadable.state === "hasError") {
            console.error("[useElement] error while loading element ".concat(elementId), elementLoadable.contents);
        }
        return null;
    }, [elementId, elementLoadable]);
    return {
        loading: elementLoadable.state === "loading",
        error: (elementLoadable.state === "hasError" && elementLoadable.contents) || null,
        element: memoElement
    };
}

export { useElement as default };
//# sourceMappingURL=hooks.js.map
